"use strict"

import { FieldSelect } from '@/lib/core/components/data/form/FieldSelect'

export class FieldLinkSimple extends FieldSelect {
  constructor({ register, fields, name }) {
    super({ register, fields, name })
  }
}